export default __webpack_public_path__ + "static/media/slide3.fc3052e1.jpg";